// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__LhQXn","disabled":"FileBtn_disabled__1Prtz","warn":"FileBtn_warn__2pczU","fade":"FileBtn_fade__2ZlTQ"};